import { render, staticRenderFns } from "./SignableDocumentsListNew.vue?vue&type=template&id=ca0870ec&"
import script from "./SignableDocumentsListNew.vue?vue&type=script&lang=ts&"
export * from "./SignableDocumentsListNew.vue?vue&type=script&lang=ts&"
import style0 from "./SignableDocumentsListNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports